import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
//import { GetUploadFile } from "../../features/fileUpload/UploadFileSlice";
import { dev } from '../../features/network/ApiCall';
import swal from 'sweetalert';
import Loader from '../loader/Loader';
import Spinner from '../Spinner/Spinner';

const FileUpload = ({
  setFile,
  title,
  fileValue,
  groupId,
  apiUrl,
  refreshList
}: {
  setFile: any;
  title: any;
  fileValue: any;
  groupId: any;
  apiUrl: any;
  refreshList: any;
}) => {
  const [fileUploaded, setFileUploaded] = useState('');
  const [filePrev, setFilePrev] = useState(fileValue);
  const [fileSize, setFileSize] = useState('');
  const [loader, setLoader] = useState(false);
  //const dispatch = useAppDispatch();
  const handleChange = (e: any) => {
    e.preventDefault();

    if (
      e.target.files[0].type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setFileUploaded(e.target.files[0]);
      setFilePrev(e.target.files[0].name);
      setLoader(true);
      var fileUploadSize = e.target.files[0].size;

      // console.log(e.target.files[0].type,"e.target.files[0]", groupId)
      var sizeInMB = (fileUploadSize / (1024 * 1024)).toFixed(2);
      const userDetails = localStorage.getItem('userDetails');
      const userDetailsList: any = userDetails;
      const userDetailsJson = JSON.parse(userDetailsList);
      setFileSize(sizeInMB + 'MB');
      if (e.target.files[0].name !== '') {
        var axios = require('axios');
        var FormData = require('form-data');
        var data = new FormData();
        data.append('pdf', e.target.files[0]);
        let headers = {
          'Content-Type': 'multipart/form-data',
          authorization: 'Bearer ' + userDetailsJson.accessToken
        };
        var config = {
          method: 'post',
          url: `${dev}/fileUpload/upload/${apiUrl}/${groupId}`,
          headers: headers,
          data: data
        };

        axios(config)
          .then(function (response: any) {
            // console.log(JSON.stringify(response.data));
            swal('Successfully uploaded', 'success');
            setLoader(false);
            setFile(response.data.url);
            refreshList();
            if (response?.data?.error) {
              // console.log(response.data.error)
              swal(response.data.error, '', 'error');
              return Promise.reject(response.data.error);
              setLoader(false);
            }
          })
          .catch(function (error: any) {});
      }
    } else {
      swal(`Please Upload Excel File`, '', 'error');
    }
  };

  return (
    <div className='floating-label-group'>
      {/* {loader===true?<Loader/>:null} */}
      <input
        type='text'
        disabled
        className='textstyle'
        defaultValue={filePrev}
      />

      <div className='file btn '>
        {filePrev !== '' ? (
          <div className='my-1'>
            <label style={styles.link2}>{fileSize}</label> &nbsp;
            <a style={styles.link}>Replace</a>
          </div>
        ) : (
          <div className='my-1'>
            <a style={styles.link}>Upload File</a>
          </div>
        )}
        <span>{loader === true ? <Spinner /> : null}</span>
        <input
          type='file'
          onChange={handleChange}
          className='fileUpload'
          name='file'
        />
      </div>
      <label className='floating-label'>
        {title} <span style={styles.star}> * </span>
      </label>
    </div>
  );
};

const styles: any = {
  star: { color: '#e31837' },
  divWhite: {
    backgroundColor: '#ffffff',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px'
  },

  button: {
    padding: '13px 20px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    color: '#fff',
    float: 'right'
  },
  button1: {
    padding: '13px 20px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#ffffff',
    border: '1px solid #e31837',
    letterSpacing: 'normal',
    color: '#e31837'
  },
  divGrey: {
    backgroundColor: 'rgb(250, 249, 249)',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '20px',
    borderTop: '1px solid #eee;'
  },

  delcontent: {
    fontSize: '16px',
    color: '#242424'
  },

  editstyle: {
    color: '#e31837',
    fontFamily: 'Saira',
    fontWeight: 600,
    fontSize: '12px',
    float: 'right',
    marginTop: '10px'
  },
  checkb: {
    boxSizing: 'border-box',
    boxShadow: 'inset 0px 0px 0px 2px #e31837',
    width: '18px',
    height: '18px',
    // marginLeft: "8px",
    marginBottom: '15px'
  },

  img: {
    backgroundColor: 'rgba(236, 236, 236, 0.3)',
    padding: '14px',
    borderRadius: '50%'
  },
  title: {
    fontFamily: 'Saira',
    fontSize: '18px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.44,
    letterSpacing: 'normal',
    paddingLeft: '5px',
    paddingTop: '10px',
    padding: '20px 5px 8px'
  },

  link: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: '#e31837',
    lineHeight: '2',
    textTransform: 'uppercase',
    textDecoration: 'none',
    float: 'right'
  },
  link2: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: 'gray',
    lineHeight: '2',
    textTransform: 'uppercase',
    textDecoration: 'none',
    float: 'left'
  },
  content: {
    fontFamily: 'Saira',
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.57,
    paddingLeft: '5px',
    marginBottom: '0.5rem'
  },

  codeofconduct: {
    border: '1px solid #eee',
    padding: '15px',
    marginBottom: '20px',
    backgroundColor: '#ffffff'
  },

  codeofconductmob: {
    border: '1px solid #eee',
    padding: '25px 20px',
    MarginBottom: '10px'
  }
};

export default FileUpload;
